import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import axios from 'axios';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function getRegions() {
    return axios
        .get(`https://which.regions-api.archireport.com/region-list?env=${import.meta.env.VITE_STAGE || 'dev'}`, {
            timeout: 4000,
        })
        .then(response => response.data)
        .catch(error => {
            console.error('Failed to fetch regions:', error);
            // Fallback to hardcoded regions
            return [
                {
                    short_region: 'eu',
                    continent: 'europe',
                    region: 'eu-central-1',
                    title: 'Web_Region_Europe',
                    short_title: 'EU',
                    web: 'https://web.archireport.com',
                    api: 'https://api.archireport.com',
                    s3_bucket: 'ar-accounts-prod',
                    websocket: 'wss://eu-prod.websocket.archireport.com',
                    default: true,
                },
                {
                    short_region: 'us',
                    continent: 'north-america',
                    region: 'us-east-1',
                    title: 'Web_Region_NorthAmerica',
                    short_title: 'US',
                    web: 'https://web.archireport.com',
                    api: 'https://us-api.archireport.com',
                    s3_bucket: 'ar-us-accounts',
                    websocket: 'wss://us-prod.websocket.archireport.com',
                },
                {
                    short_region: 'au',
                    continent: 'oceania',
                    region: 'ap-southeast-2',
                    title: 'Web_Region_Oceania',
                    short_title: 'AU',
                    web: 'https://web.archireport.com',
                    api: 'https://au-api.archireport.com',
                    s3_bucket: 'ar-au-accounts',
                    websocket: 'wss://au-prod.websocket.archireport.com',
                },
            ];
        });
}
